exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.project-container > .el-dialog__body {\n  min-height: 400px;\n}\n.project-container > .el-dialog__body > .el-table {\n    border: 1px solid #efefef !important;\n    border-right: none !important;\n    height: 100%;\n}\n.project-container > .el-dialog__footer > .footer-wrap > .el-pagination {\n  float: left;\n}\n.project-container > .el-dialog__footer > .footer-wrap > .el-pagination button {\n    padding: 0 !important;\n}\n.project-container > .el-dialog__footer > .footer-wrap > .right-wrap > span {\n  font-size: 13px;\n  margin-right: 5px;\n  color: #606266;\n}\n.project-container > .el-dialog__footer > .footer-wrap > .right-wrap > span > strong {\n    color: #333333;\n    margin: 0 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66691970","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/paperTitleAndOption.vue
// module id = aymL
// module chunks = 289